import React from 'react';
import {Bar} from '../react-chartjsx/src';//'react-chartjsx';

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';

import './VerticalBarGraph.css';

const verticalBarGraph = (props) => {

    // Bar Parameters
    const barData = {
        labels: props.data[0],
        datasets: [{
            label: 'NPS',
            type: 'line',
            data: props.data[1],
            fill: false,
            borderColor: '#36A2EB',
            backgroundColor: '#36A2EB',
            pointBorderColor: '#36A2EB',
            pointBackgroundColor: '#36A2EB',
            pointHoverBackgroundColor: '#36A2EB',
            pointHoverBorderColor: '#36A2EB',
            yAxisID: 'y-axis-2'
        },{
            label: 'Sad',
            data: props.data[2],
            fill: false,
            backgroundColor: '#EE2930',
            borderColor: '#EE2930',
            hoverBackgroundColor: '#EE2930',
            hoverBorderColor: '#EE2930',
            yAxisID: 'y-axis-1'
        },{
            label: 'Neutral',
            data: props.data[3],
            fill: false,
            backgroundColor: '#F5EE34',
            borderColor: '#F5EE34',
            hoverBackgroundColor: '#F5EE34',
            hoverBorderColor: '#F5EE34',
            yAxisID: 'y-axis-1'
        },{
            label: 'Happy',
            data: props.data[4],
            fill: false,
            backgroundColor: '#47B749',
            borderColor: '#47B749',
            hoverBackgroundColor: '#47B749',
            hoverBorderColor: '#47B749',
            yAxisID: 'y-axis-1'
        }]
    };

    const barOptions = {
        responsive: true,
        tooltips: {
           mode: 'label',
           callbacks: {
               label: function(tooltipItem, data) {
                   let label = data.datasets[tooltipItem.datasetIndex].label || '';
                   let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                   
                    if (label) {
                        label += ': ';
                    }
                    label += (tooltipItem.datasetIndex === 0 ? value.toFixed(1) : value.toFixed(0));
                    return label;
               }
           }
        },
        legend: {
            display: false
        },
        maintainAspectRatio: false,
        scales: {
            xAxes: [
                {
                    display: true,
                    gridLines: {
                        display: false
                    },
                    stacked: true
                    //labels: {
                    //  show: true
                    //}
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    id: 'y-axis-1',
                    gridLines: {
                        display: false
                    },
                    labels: {
                        show: true
                    },
                    stacked: true,
                    ticks: {
                        min: 0,
                        max: 100,
                        //beginAtZero: true,
                        precision: 0
                    }
                },
                {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    id: 'y-axis-2',
                    gridLines: {
                        display: false
                    },
                    labels: {
                        show: true
                    },
                    ticks: {
                        beginAtZero: true,
                        //precision: 0,
                        min: 0,
                        max: 100
                    }
                }
            ]
        }
    };

    // const barEvent = (e) => {
    //     console.log(e);
    //     //if (e.length !== 0){
    //     //    let index = e[0]._index;
    //     //}
    // }

    return (
        <Auxiliary>
            <div className="VerticalBarGraphHeader"><span>{props.title}</span></div>
            <div className="VerticalBarGraphBody">
                <Bar
                    data={barData}
                    options={barOptions}
                    //onElementsClick={barEvent}
                    height={300}
                />
            </div>
        </Auxiliary>
    );
};

export default verticalBarGraph;